import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=1f1d29e1"
import script from "./CustomTable.vue?vue&type=script&lang=ts"
export * from "./CustomTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=1f1d29e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports